// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"594":"2ff5883c","729":"ecd63852"}[chunkId] + ".chunk.css";
};